// src/services/controleBar/ComprovantePagComandaService.js
import { fetchBlobData, postData } from '../Api';

export const getComprovantePagComandaPDF = async (comandaId) =>
  fetchBlobData('/Comanda/ComprovantePagamentoPDF', { comandaId });

export const solicitarComprovantePagComandaMonitor = async (comandaId) =>
  postData(`/Comanda/SolicitarImpressaoComprovantePagamento?comandaId=${comandaId}`);
